import React from "react";
import {AdditiveIcon, ChildIcon, ParentIcon, SubtractiveIcon, AlternateIcon} from "../Icons/Icons";
import LibraryComponent from "../LibraryComponent/LibraryComponent";

const style = {height: 20, marginBottom: 4, marginLeft: -8, marginRight: 2}
function getRelationshipIcon(relation) {
    switch (relation) {
        case 'Parent':
            return <ParentIcon style={style}/>
        case 'Child':
            return <ChildIcon style={style}/>
        case 'Additive':
            return <AdditiveIcon style={{...style, color: "#284B9E", height: 16, marginBottom: 5}}/>
        case 'Subtractive':
            return <SubtractiveIcon style={{...style, color: "#284B9E", height: 16, marginBottom: 5}}/>
        case "Alternate":
            return <AlternateIcon style={{...style}}/>;
        default:
            return <React.Fragment/>;
    }
}

function mapRelationToDefinition(relation) {
    switch (relation) {
        case 'Parent':
            return {title: "Parent Pattern", text: "A pattern or several patterns that are required by this pattern or require it to function well."}
        case 'Child':
            return {title: "Child Pattern", text: "Patterns that are suggested by this pattern or require it to function well."}
        case 'Additive':
            return {title: "Additive Pattern", text: "Patterns that work well together and improve each other, but where one does not require the other to function."}
        case 'Subtractive':
            return {title: "Subtractive Pattern", text: "Patterns where one reduces the effectiveness of another."}
        case 'Alternate':
            return {title: "Alternate Pattern", text: "Patterns that solve the same problem, but where one should probably replace the other rather than combine with it."}
        default:
            return {title: "", text: ""};
    }
}

export function RelatedPattern({related_pattern, patternSelected, update = (val) => {}, isMerged = false, disableClick = false, fromStyles = false, liveEdit = false}) {
    const related_pattern_key = related_pattern.related_pattern_id + "_" + related_pattern.pattern_relationship;
    const relatedText = mapRelationToDefinition(related_pattern.pattern_relationship);

    return <LibraryComponent uniqueId={related_pattern.related_pattern_id} onClick={disableClick ? ()=>{} : () => patternSelected(related_pattern.related_pattern_id)}
                             itemKey={related_pattern_key} name={related_pattern.pattern_name}
                             popoverText={relatedText}
                             getIcon={() => getRelationshipIcon(related_pattern.pattern_relationship)}
                             startDesc={related_pattern.relationship_description}
                             update={update}
                             isMerging={isMerged}
                             fromStyles={fromStyles}
                             liveEdit={liveEdit}
    >
    </LibraryComponent>
}